import React from 'react';
import { Filter, SortAsc } from 'lucide-react';
import CustomSelect from './components/CustomSelect';
import SearchFilters from './components/SearchFilters';
import DateRangeFilter from './components/DateRangeFilter';

/**
 * 질의 내역 페이지 상단의 통합 필터 컴포넌트.
 * 검색, 기간 선택, 상태 필터, 정렬 기능을 포함합니다.
 */
const HistoryFilter = ({
    viewMode = 'personal',
    personalSearch = '',
    setPersonalSearch,
    companyNameSearch = '',
    setCompanyNameSearch,
    companyContentSearch = '',
    setCompanyContentSearch,
    adminCompanySearch = '',
    setAdminCompanySearch,
    startDate = '',
    setStartDate,
    endDate = '',
    setEndDate,
    clearDateFilter,
    statusFilter = 'all',
    setStatusFilter,
    sortOrder = 'desc',
    setSortOrder,
}) => {
    // 필터 옵션 설정
    const statusOptions = [
        { value: 'all', label: '모든 상태' },
        { value: 'success', label: '정상 응답' },
        { value: 'no_answer', label: '미답변' },
        { value: 'error', label: '처리 오류' },
        { value: 'timeout', label: '시간 초과' },
        { value: 'partial', label: '부분 응답' },
    ];

    const sortOptions = [
        { value: 'desc', label: '최신순' },
        { value: 'asc', label: '오래된순' },
    ];

    return (
        <div className="bg-[#f8fafc] p-5 rounded-3xl border border-gray-100 shadow-sm">
            {/* 상단: 검색 및 기간 필터 */}
            <div className="flex flex-col md:flex-row gap-3">
                <SearchFilters 
                    viewMode={viewMode}
                    personalSearch={personalSearch}
                    setPersonalSearch={setPersonalSearch}
                    companyNameSearch={companyNameSearch}
                    setCompanyNameSearch={setCompanyNameSearch}
                    companyContentSearch={companyContentSearch}
                    setCompanyContentSearch={setCompanyContentSearch}
                    adminCompanySearch={adminCompanySearch}
                    setAdminCompanySearch={setAdminCompanySearch}
                />
                
                <DateRangeFilter 
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    clearDateFilter={clearDateFilter}
                />
            </div>

            {/* 하단: 상태 필터 및 정렬 방식 */}
            <div className="grid grid-cols-2 md:flex md:flex-wrap gap-2 md:gap-3 pt-3 border-t border-gray-100 mt-3">
                <CustomSelect
                    label="응답 상태"
                    value={statusFilter ?? 'all'}
                    options={statusOptions}
                    onChange={(v) => setStatusFilter?.(v)}
                    icon={Filter}
                    className="rounded-full"
                />
                <CustomSelect
                    label="정렬 방식"
                    value={sortOrder ?? 'desc'}
                    options={sortOptions}
                    onChange={(v) => setSortOrder?.(v)}
                    icon={SortAsc}
                    className="rounded-full"
                />
            </div>
        </div>
    );
};

export default HistoryFilter;
